import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana19Div2M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
    <rect width="1221" height="921" fill="url(#pattern0_1467_37585)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M659.512 482.11L619.804 500.159L587.316 429.768L636.048 408.109C643.869 424.353 660.234 458.647 663.122 465.866C666.01 473.086 661.918 479.704 659.512 482.11Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M608.978 352.161L636.051 408.113L581.904 431.575L554.83 368.405C563.253 364.193 581.6 355.341 590.195 352.161C599.953 348.55 606.082 350.356 608.978 352.161Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M500.68 393.674L554.827 368.405L581.9 431.577L527.753 456.845L500.68 393.674Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M571.069 523.625L619.802 500.162L587.313 429.771L538.581 451.429L571.069 523.625Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M518.723 547.089L571.065 523.626L538.577 451.43L489.845 473.088L518.723 547.089Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M469.996 568.747L518.728 547.088L489.849 473.087L441.117 494.746L469.996 568.747Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M446.528 417.133L500.675 393.669L527.749 456.84L473.602 480.304L446.528 417.133Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M394.188 440.601L446.531 417.138L473.604 480.309L419.457 503.773L394.188 440.601Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M423.067 588.6L469.994 568.746L441.116 494.745L394.188 514.599L423.067 588.6Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M374.337 608.459L423.069 588.605L394.191 514.604L343.654 536.263L374.337 608.459Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M323.799 630.115L374.336 608.456L343.653 536.26L294.921 557.919L323.799 630.115Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M340.048 464.062L394.195 440.599L419.463 503.77L363.512 527.234L340.048 464.062Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M316.583 473.087L340.047 464.062L363.51 527.234L294.924 557.917L284.095 559.722L316.583 473.087Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M247.992 628.307L284.09 559.721L294.92 557.916L323.799 630.112L258.821 653.576C245.826 650.688 246.187 635.527 247.992 628.307Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
      <pattern id="pattern0_1467_37585" patternContentUnits="objectBoundingBox" width="1" height="1">
      <use href="#image0_1467_37585" transform="matrix(0.00247572 0 0 0.00328214 -5.12437 -1.49186)"/>
      </pattern>
      <image id="image0_1467_37585"  width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};